import React, { useEffect, useState } from 'react'
import {Select, Input, Button, Tooltip, Spin,InputNumber} from 'antd'
import { ajaxApi } from '../../../server/index'
import { getParmUrl,numFormat,getCookieNew } from '../../../public/utils'
import _,{ get,set, toString } from 'lodash'
import common from '@/public/common'
import styles from './index.module.less'
import {QuestionCircleOutlined} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import {cooperationInformationRequiredverificationFun, priceUnitFunc, getSettlePriceTooltipText } from '../utils'
const Option = Select.Option
// var api = 'http://192.168.10.220:8120/'||common.scpUrl+""
var api = common.scpUrl+""


const CooperationInformation = (props) => {
  const history = useHistory()
  const {getCurrent} = props
  const [addData, setaddData] = useState(JSON.parse(sessionStorage.getItem('addData')))
  const [btnsLoading, setbtnsLoading] = useState({
    preservationLoading: false,
    okLoading: false,
    spinLoading: false
  })
  const paydayOptions = [
    {value: 0, label: '0天'}, {value: 15, label: '15天'}, {value: 30, label: '30天'}, {value: 45, label: '45天'},
    {value: 60, label: '60天'}, {value: 90, label: '90天'}, {value: 120, label: '120天'},
    {value: 150, label: '150天'}, {value: 180, label: '180天'}, {value: 360, label: '360天'}
  ]
  const paydayOptionsOther = [
    {value: 15, label: '15天'}, {value: 30, label: '30天'}, {value: 45, label: '45天'},
    {value: 60, label: '60天'}, {value: 90, label: '90天'}, {value: 120, label: '120天'},
    {value: 150, label: '150天'}, {value: 180, label: '180天'}, {value: 360, label: '360天'}
  ]
  var supplierTradeType = get(getCookieNew('supplierinfo')?JSON.parse(getCookieNew('supplierinfo')):'','trade_type')

  
  const [twoType,setTwoType] = useState(null) 
  //搜索得到的品牌方下拉值
  const [searchBrandCompanyArr,setSearchBrandCompanyArr] = useState([])
  const [openBrandList, setOpenBrandList] = useState(false)


  useEffect(()=>{
    getTwoType()
    getQueryBrand()
  },[])

  // 查询品牌
  const getQueryBrand = async () => {
    var val = get(addData, 'item_info.brand_sid')
    var searchBrandCompanyArr = []
    if (val) {
      searchBrandCompanyArr = props.brandCompanys.filter(item => {
        return item.id == val
      })
    }
    setSearchBrandCompanyArr(searchBrandCompanyArr)
  }

  const getTwoType=()=>{
    var goodsIsImport = get(addData,'item_info.is_import')
    var goodsIsCrossBorder = get(addData,'item_info.is_cross_border')
    var twoType = null
    //1：当商品是进口+非海淘，且供应商的贸易类型是进口：删除含税结算单价，显示贸易术语，工厂出厂价，含税结算成本，税率随着贸易术语变(DDP是0，其他是13)（如是oem品牌？，则显示是否品牌字段，是则带出以下必填字段:品牌费含税单价，币种，品牌商）
    //2：供应商的贸易类型是国内贸易时：含税结算成本（如是oem品牌？，则显示是否品牌字段，是则带出以下必填字段:品牌费含税单价，币种，品牌商）
    //3：当商品是海淘，且供应商的贸易类型是跨境贸易时：加贸易术语（必填），含税结算成本
    if(!goodsIsCrossBorder&&goodsIsImport&&supplierTradeType=='CommonJKTrade'){
      twoType = 1
    }
    if(supplierTradeType=='GNTrade'){
      twoType = 2
    }
    if(goodsIsCrossBorder&&supplierTradeType=='KJTrade'){
      twoType = 3
    }
    setTwoType(twoType)
    if(twoType){
      if([1, 2].includes(twoType)&& getIsOemBrand()){
        if(!get(addData,'item_info.is_have_brand_fee')){
          //有是否有品牌费的话，且非是时：默认否
          set(addData,'item_info.is_have_brand_fee',0)
        }
      }else{
        set(addData,'item_info.is_have_brand_fee',0)
      }
      getSettlePrice(addData)
    }else{
      _.defer(()=>{
        updateAddData('item_info.is_have_brand_fee',null)
      },1000)
      getConvertCnyCurrency({
        'code':get(addData,'item_info.currency'),
        'value':get(addData,'item_info.base_price'),
      })
    }
    setaddData(addData )
    sessionStorage.setItem('addData', JSON.stringify(addData))
  }

  const updateAddData=(key,val)=>{
    const addDataClone = _.clone(addData)
    set(addDataClone,key,val)
    setaddData(addDataClone )
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 获取下拉框的值
  const handelChangeSource = (e, name) => {
    const addDataClone = _.cloneDeep(addData)
    addDataClone.item_info[name] = e
    if(name == 'pay_type'&&['货到付款','预付款'].includes(e)){
      set(addDataClone,'item_info.pay_day',null)
    }
    if(name=='trade_code'){
      //根据贸易术语带出税率：DDP是0，其他是13
       var tax_rate= e=='DDP'?0:13
      set(addDataClone,'item_info.tax_rate',e?tax_rate:undefined)
    }
    if(name=='brand_sid'){
      setOpenBrandList(false)
    }
    if(name=='is_have_brand_fee'&&!e){
      set(addDataClone,'item_info.brand_fee',undefined)
      set(addDataClone,'item_info.brand_currency',undefined)
      set(addDataClone,'item_info.brand_sid',undefined)
    }
    if(['trade_code','is_have_brand_fee','brand_sid'].includes(name)){
      getSettlePrice(addDataClone)
    }
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 获取输入框的值
  const handleChangeInput = (e, name) => {
    const addDataClone = _.clone(addData)
    addDataClone.item_info[name] = e.target.value
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  const iptNumChange=(value,key)=>{
    const addDataClone = _.clone(addData)
    addDataClone.item_info[key] = value
    setaddData(addDataClone)
    if(!twoType&&key=='base_price'){
      var params = {
        'code':get(addData,'item_info.currency'),
        'value':value,
      }
      getConvertCnyCurrency(params)
    }
    if(twoType&&['base_price','brand_fee'].includes(key)){
      getSettlePrice(addDataClone)
    }
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  const selectCurrent = (e, name) => {
    const addDataClone = _.clone(addData)
    addDataClone.item_info[name] = e
    setaddData(addDataClone)
    if(!twoType&&name=='currency'){
      var params = {
        'code':e,
        'value':get(addData,'item_info.base_price'),
      }
      getConvertCnyCurrency(params)
    }
    if(twoType&&['currency','brand_currency'].includes(name)){
      getSettlePrice(addDataClone)
    }
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  const getConvertCnyCurrency =(params)=>{
    if(get(params,'code')&&get(params,'value')){
      getConvertCnyCurrencyAxios(params)
    }else{
      const addDataClone = _.clone(addData)
      addDataClone.item_info['settle_price'] = 0
      setaddData(addDataClone)
      sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    }
  }


  const getConvertCnyCurrencyAxios= async (params) => {
    try {
      let res = await ajaxApi({
        url: common.scpUrl+'item/convertCnyCurrency',
        params
      })
      const addDataClone = _.clone(addData)
      addDataClone.item_info['settle_price'] = get(res,'data.data.value')
      setaddData(addDataClone)
      sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    } catch (e) {
      // console.log(e)
    }
  }

  // 动态匹配品牌
  const handleSearch = (e, key) => {
    if (key == 'brand') {
      var searchBrandCompanyArr = []
      if (e) {
        searchBrandCompanyArr = props.brandCompanys.filter(item => {
          return item.name.indexOf(e) > -1
        })
      }
      setSearchBrandCompanyArr(searchBrandCompanyArr)
    }
    
  }

  const getIsOemBrand=()=>{
    var brand_name = get(addData, 'item_info.brand_name')
    // if(get(addData,'item_info.brand_id') instanceof Array){
    //   brand_id = get(addData, 'item_info.brand_id[0]')
    // }
    // console.log(get(_.filter(props.brandArr,['name',brand_name]),'0.is_oem'))
    // console.log('oem-品牌',_.filter(props.brandArr,['is_oem',1]))
    return get(_.filter(props.brandArr,['name',brand_name]),'0.is_oem')
  }

  const getSettlePrice=async(addData)=>{
    var params = {
      trade_type:supplierTradeType,
      trade_code:get(addData, 'item_info.trade_code'),
      is_import:get(addData, 'item_info.is_import'),
      is_cross_border:get(addData, 'item_info.is_cross_border'),
      base_price:get(addData, 'item_info.base_price'),
      currency:get(addData, 'item_info.currency'),
      is_have_brand_fee:get(addData, 'item_info.is_have_brand_fee'),
      brand_fee:get(addData, 'item_info.brand_fee'),
      brand_currency:get(addData, 'item_info.brand_currency'),
      brand_sid:get(addData, 'item_info.brand_sid'),
    }
    try {
      let res = await ajaxApi({
        url: api+'item/calc-price',
        params
      })
      const addDataClone = _.clone(addData)
      addDataClone.item_info['settle_price'] = get(res,'data.data')
      setaddData(addDataClone)
      sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    } catch (e) {
      // console.log(e)
    }
  }

  // 保存
  const handlePreservation = () => {
    var isOemBrand = getIsOemBrand()
    const isRequire = cooperationInformationRequiredverificationFun(addData,twoType,isOemBrand)
    if (isRequire === undefined) {
      publicFunc('save')
    }
  }

  // 提交
  const handleOk = () => {
    var isOemBrand = getIsOemBrand()
    const isRequire = cooperationInformationRequiredverificationFun(addData,twoType,isOemBrand)
    if (isRequire === undefined) {
      publicFunc('submit')
    }
  }

  const selectTom = () => {
    if (addData && ['固定账期（月结）','固定账期（季结）'].includes(addData.item_info.pay_type)) {
      return (
        <Select
          showSearch
          style={{ width: 90, marginRight: '4px' }}
          optionFilterProp="children"
          placeholder='请选择'
          allowClear
          options={ paydayOptionsOther}
          value={addData && addData.item_info ? addData.item_info.pay_day  : ''}
          onChange={(e) => handelChangeSource(e, 'pay_day')}
        />
      )
    } else if (addData && addData.item_info.pay_type === '实销实结') {
      return (
        <Select
          showSearch
          style={{ width: 90, marginRight: '4px' }}
          optionFilterProp="children"
          placeholder='请选择'
          allowClear
          options={ paydayOptions}
          value={addData && addData.item_info ? addData.item_info.pay_day  : ''}
          onChange={(e) => handelChangeSource(e, 'pay_day')}
        />
      )
    } else if (addData && addData.item_info.pay_type === '滚动账期') {
      return (
        <Input
          value={addData ? addData.item_info.pay_day : ''}
          placeholder="请输入"
          name="pay_day"
          onChange={(e) => handleChangeInput(e, 'pay_day')}
          style={{ width: 90, marginRight: '0px' }}
        />
      )
    } else {
      return ''
    }
  }

  //  上一步
  const handleBack = () => {
    getCurrent(1)
  }

  const publicFunc = async (action) => {
    const _addData = _.cloneDeep(addData)
    try {
      let url = ''
      if (getParmUrl('type') === 'add') {
        url = api+'/item/add'
      } else {
        url = api+'item/update'
      }
      if (action === 'save') {
        _addData.action = action
        setbtnsLoading({...btnsLoading, preservationLoading: true, spinLoading: true})
      }
      if (action === 'submit') {
        _addData.action = action
        setbtnsLoading({...btnsLoading, okLoading: true, spinLoading: true})
      }
      if (_addData && _addData.sku_propertys) {
        if (_addData.sku_propertys.length !== 0) {
          _addData.sku_propertys.forEach((itme) => {
            // 去掉数组中的假值，返回一个新数组如false, null,0, "", undefined, 和 NaN 都是被认为是“假值”。
            itme.sku_value = _.compact(itme.sku_value)
          })
        }
      }
      if (_.get(_addData,'item_info.brand_id') instanceof Array) {
        _addData.item_info.brand_id = _addData.item_info.brand_id[0]
      }
      if (_.get(_addData,'item_info.brand_name') instanceof Array) {
        _addData.item_info.brand_name = _addData.item_info.brand_name[0]
      }
      if (_.get(_addData,'item_info.create_company') instanceof Array) {
        _addData.item_info.create_company = _addData.item_info.create_company[0]
      }
      if (_.get(_addData,'credentialData.type', 'add') === 'add') {
        // _.set(_addData, 'item_info.brand_id', null)
        _.set(_addData, 'brand_qualification.brand_id', null)
      }
      _.set(_addData, 'item_info.brand_id', get(_.filter(props.brandArr,['name',get(addData, 'item_info.brand_name')]),'0.id')||null)
      _.set(_addData, 'item_info.trade_type', supplierTradeType)
      _.set(_addData, 'item_info.is_oem_brand', getIsOemBrand())
      _.set(_addData, 'item_info.spec', get(_addData,"item_info.spec")?toString(_addData.item_info.spec):_addData.item_info.spec) // 规格转成字符串
      if(!getIsOemBrand()){
        set(_addData,'item_info',{
          ...get(_addData,'item_info'),
          is_have_brand_fee:null,
          brand_fee:null,
          brand_currency:null,
          brand_sid:null,
        })
      }
      console.log(_addData, '_addData')
      // _.set(_addData, 'item_info.purchase_company', getCookieNew("businessId"))
      _.set(_addData, 'item_info.purchase_company', getCookieNew('po_subject_code'))
      // 商品类目编码（URL 带入）及其父类目编码（类型下拉选中的子类目 category_code）
      _.set(_addData, 'item_info.category_code', getParmUrl('categorycode') || null)
      _.set(_addData, 'item_info.parent_category_code', get(addData, 'item_info.item_color_type') || null)
      const res = await ajaxApi({
        url: url,
        params: _addData
      })
      setbtnsLoading({...btnsLoading, okLoading: false, preservationLoading: false, spinLoading: false})
      console.log(res)
      if (res.status === 200) {
        history.push({pathname: '/main/commoditymanagement/commoditymanagementlist/commodity-management-list'})
      }
    } catch (e) {
      setbtnsLoading({...btnsLoading, okLoading: false, preservationLoading: false})
      console.log(e)
    }
  }

  const getTradeCodesByTradeType=()=>{
    //通过贸易类型拿贸易术语
    if(supplierTradeType=='KJTrade'){return get(props, 'tradeCodes.kj_trade')}
    if(supplierTradeType=='CommonJKTrade'){return get(props, 'tradeCodes.jk_trade')}
  }

  return (
    <Spin spinning ={btnsLoading.spinLoading}>
      <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
        <div style={{ width: '100%' }}>
          <div className={styles.total_title}>
            <span className={styles.titles}>合作政策</span>
          </div>
          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>经营属性：</span>
              <Select
                showSearch
                allowClear
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={addData && addData.item_info.operation ? addData.item_info.operation : undefined}
                onChange={(e) => handelChangeSource(e, 'operation')}
              >
                <Option key={1} name='operation' value='direct'>经销</Option>
                <Option key={2} name='operation' value='tp'>代销</Option>
              </Select>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>是否独家销售：</span>
              <Select
                showSearch
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && (addData.item_info.is_one_sale || addData.item_info.is_one_sale === 0) ? addData.item_info.is_one_sale : undefined}
                onChange={(e) => handelChangeSource(e, 'is_one_sale')}
              >
                <Option key={1} name='is_one_sale' value={1}>是</Option>
                <Option key={2} name='is_one_sale' value={0}>否</Option>
              </Select>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>铺货方式：</span>
              <Select
                showSearch
                style={{ width: 90, marginRight: '4px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && addData.item_info.distribute_type ? addData.item_info.distribute_type : undefined}
                onChange={(e) => handelChangeSource(e, 'distribute_type')}
              >
                <Option key={1} name='distribute_type' value={'金额'}>金额</Option>
                <Option key={2} name='distribute_type' value={'盒数'}>盒数</Option>
              </Select>
              <InputNumber
                placeholder='请输入'
                // min={get(addData,'item_info.distribute_type') === '金额'&&0}
                max={999999}
                precision={2}
                value={(get(addData,'item_info.distribute_number')||get(addData,'item_info.distribute_number')=='0')?Number(get(addData,'item_info.distribute_number')):null}
                onChange={(e)=>{iptNumChange(e,'distribute_number')}}
                style={{ width: 144, marginRight: '0px',marginRight:"4px" }}
              />{get(addData,'item_info.distribute_type') === '盒数' && '盒'}
                { get(addData,'item_info.distribute_type') === '金额' &&'¥'}
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}></span>推广政策：</span>
              <Input
                value={addData ? addData.item_info.promote_desc : ''}
                placeholder="请输入"
                name="promote_desc"
                allowClear
                onChange={(e) => handleChangeInput(e, 'promote_desc')}
                style={{ width: 244, marginRight: '0px' }}
              />
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}></span>
                <Tooltip title="买几赠几+活动周期"><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>采购活动：
              </span>
              <Input
                value={addData ? addData.item_info.purchase_desc : ''}
                placeholder="请输入"
                name="purchase_desc"
                allowClear
                onChange={(e) => handleChangeInput(e, 'purchase_desc')}
                style={{ width: 244, marginRight: '0px' }}
              />
            </section>
          </div>

          <div className={styles.total_title}>
            <span className={styles.titles}>结算政策</span>
          </div>

          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>账期：
              </span>
              <Select
                showSearch
                style={{ width: ((addData && ['固定账期（月结）','固定账期（季结）'].includes(addData.item_info.pay_type)) ||
                (addData && addData.item_info.pay_type === '实销实结') ||
                (addData && addData.item_info.pay_type === '滚动账期')) ? 150 : 244,
                marginRight: '4px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && addData.item_info.pay_type ? addData.item_info.pay_type : undefined}
                onChange={(e) => handelChangeSource(e, 'pay_type')}
              >
                <Option key={1} name='pay_type' value={'固定账期（月结）'}>固定账期（月结）</Option>
                <Option key={2} name='pay_type' value={'固定账期（季结）'}>固定账期（季结）</Option>
                <Option key={3} name='pay_type' value={'滚动账期'}>滚动账期</Option>
                <Option key={4} name='pay_type' value={'实销实结'}>实销实结</Option>
                <Option key={5} name='pay_type' value={'货到付款'}>货到付款</Option>
                <Option key={6} name='pay_type' value={'预付款'}>预付款</Option>
              </Select>
              {selectTom()}
            </section>

            {
              [1,3].includes(twoType) &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>贸易术语：
                </span>
                <Select
                  showSearch
                  style={{ width: 244,marginRight: '4px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  allowClear
                  value={get(addData, 'item_info.trade_code') || undefined}
                  onChange={(e) => handelChangeSource(e, 'trade_code')}
                >
                  {
                    (getTradeCodesByTradeType()||[]).map(item => (
                      <Option key={get(item, 'dict_name')} name='trade_code' value={get(item, 'dict_name')}>{get(item, 'dict_name')}</Option>
                    ))
                  }
                </Select>
              </section>
            }

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>税率：
              </span>
              <InputNumber
                placeholder='请输入'
                max={100}
                precision={2}
                disabled={[1].includes(twoType)}
                value={(get(addData,'item_info.tax_rate')||get(addData,'item_info.tax_rate')=='0') ?Number(get(addData,'item_info.tax_rate')):null}
                onChange={(e)=>{iptNumChange(e,'tax_rate')}}
                style={{ width: 144, marginRight: '0px',marginRight:"4px" }}
              />%
            </section>

            {
              twoType == 1 &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>工厂出厂价：
                </span>
                <InputNumber
                  placeholder='请输入'
                  min={0}
                  max={999999}
                  precision={6}
                  value={(get(addData, 'item_info.base_price') || get(addData, 'item_info.base_price') == '0') ? Number(get(addData, 'item_info.base_price')) : null}
                  onChange={(e) => { iptNumChange(e, 'base_price') }}
                  style={{ width: 144, marginRight: '8px', marginLeft: "4px" }}
                />
                <Select
                  showSearch
                  style={{ width: 88 }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && addData.item_info.currency ? addData.item_info.currency : undefined}
                  onChange={(e) => selectCurrent(e, 'currency')}
                >
                  {
                    get(props.currentList, 'length') &&
                    props.currentList.map(item => {
                      return (
                        <Option name='pay_type' value={get(item, 'code')}>{get(item, 'name')}</Option>
                      )
                    })
                  }
                </Select>
              </section>
            }
            {
              twoType != 1 &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>含税结算单价：
                </span>
                <InputNumber
                  placeholder='请输入'
                  min={0}
                  max={999999}
                  precision={6}
                  value={(get(addData, 'item_info.base_price') || get(addData, 'item_info.base_price') == '0') ? Number(get(addData, 'item_info.base_price')) : null}
                  onChange={(e) => { iptNumChange(e, 'base_price') }}
                  style={{ width: 144, marginRight: '8px', marginLeft: "4px" }}
                />
                <Select
                  showSearch
                  style={{ width: 88 }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && addData.item_info.currency ? addData.item_info.currency : undefined}
                  onChange={(e) => selectCurrent(e, 'currency')}
                >
                  {
                    get(props.currentList, 'length') &&
                    props.currentList.map(item => {
                      return (
                        <Option name='pay_type' value={get(item, 'code')}>{get(item, 'name')}</Option>
                      )
                    })
                  }
                </Select>
                {
                  !twoType &&
                  <span style={{ marginLeft: '8px' }}>￥{numFormat(get(addData, 'item_info.settle_price'))}</span>
                }
              </section>
            }
            {
              [1, 2].includes(twoType) && getIsOemBrand() &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>是否有品牌使用费：
                </span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '4px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  allowClear
                  value={(get(addData, 'item_info.is_have_brand_fee') || get(addData, 'item_info.is_have_brand_fee') == '0') ? get(addData, 'item_info.is_have_brand_fee') : undefined}
                  onChange={(e) => handelChangeSource(e, 'is_have_brand_fee')}
                >
                  <Option key={1} name='is_have_brand_fee' value={1}>是</Option>
                  <Option key={2} name='is_have_brand_fee' value={0}>否</Option>
                </Select>
              </section>
            }

            {
              [1, 2].includes(twoType) && getIsOemBrand() && Number(get(addData, 'item_info.is_have_brand_fee'))>0 &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>品牌费含税单价：
                </span>
                <InputNumber
                  placeholder='请输入'
                  min={0}
                  max={999999}
                  precision={6}
                  value={(get(addData, 'item_info.brand_fee') || get(addData, 'item_info.brand_fee') == '0') ? Number(get(addData, 'item_info.brand_fee')) : null}
                  onChange={(e) => { iptNumChange(e, 'brand_fee') }}
                  style={{ width: 144, marginRight: '8px', marginLeft: "4px" }}
                />
                <Select
                  showSearch
                  style={{ width: 88 }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && addData.item_info.brand_currency ? addData.item_info.brand_currency : undefined}
                  onChange={(e) => selectCurrent(e, 'brand_currency')}
                >
                  {
                    get(props.currentList, 'length') &&
                    props.currentList.map(item => {
                      return (
                        <Option name='pay_type' value={get(item, 'code')}>{get(item, 'name')}</Option>
                      )
                    })
                  }
                </Select>
              </section>


            }
            {
              [1, 2].includes(twoType) && getIsOemBrand() && Number(get(addData, 'item_info.is_have_brand_fee'))>0 &&

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>品牌方：
                </span>
                <Select
                  open={openBrandList}
                  showSearch
                  style={{ width: 244, marginRight: '4px' }}
                  optionFilterProp="children"
                  placeholder='支持搜索后选择'
                  allowClear
                  value={get(addData, 'item_info.brand_sid') || undefined}
                  onChange={(e) => handelChangeSource(e, 'brand_sid')}
                  onSearch={(e) => {
                    setOpenBrandList(true)
                    handleSearch(e, 'brand')
                  }}
                  onFocus={() => {
                    setOpenBrandList(true)
                    handelChangeSource(null, 'brand_sid')
                  }}
                >
                  {
                    (searchBrandCompanyArr || []).map(item => (
                      <Option key={get(item, 'id')} value={get(item, 'id')}>{get(item, 'name')}</Option>
                    ))
                  }
                </Select>
              </section>
            }

            {
              twoType &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  {getSettlePriceTooltipText(twoType)}
                  含税结算成本：
                </span>
                ￥{numFormat(get(addData, 'item_info.settle_price'))}
              </section>
            }
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>计价单位：
                </span>
              <Select
                showSearch
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                fieldNames={{label:"dict_name",value:"dict_key"}}
                value={addData && (addData.item_info.price_unit || addData.item_info.price_unit === 0) ? addData.item_info.price_unit : undefined}
                // options={addData && addData.item_info.spec_unit ? priceUnitFunc(addData.item_info.spec_unit) : []}
                options={priceUnitFunc() }
                onChange={(e) => handelChangeSource(e, 'price_unit')}
              />
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                <Tooltip title="给工厂下订单至供应商入库时间">
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                </Tooltip>生产周期：
              </span>
              <Input
                value={addData ? addData.item_info.produce_cycle : ''}
                placeholder="请输入"
                name="produce_cycle"
                addonAfter='天'
                allowClear
                onChange={(e) => handleChangeInput(e, 'produce_cycle')}
                style={{ width: 244, marginRight: '0px' }}
              />
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                <Tooltip title="供应商发货到视客入库时间">
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                </Tooltip>发货天数：
              </span>
              <Input
                value={addData ? addData.item_info.delivery_day : ''}
                placeholder="请输入"
                name="delivery_day"
                addonAfter='天'
                allowClear
                onChange={(e) => handleChangeInput(e, 'delivery_day')}
                style={{ width: 244, marginRight: '0px' }}
              />
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>建议零售价： </span>
              <InputNumber
                placeholder='请输入'
                min={0}
                max={999999}
                precision={2}
                addonBefore='¥'
                value={(get(addData,'item_info.sale_price')||get(addData,'item_info.sale_price')=='0')?Number(get(addData,'item_info.sale_price')):null}
                onChange={(e)=>{iptNumChange(e,'sale_price')}}
                style={{ width: 144, marginRight: '0px',marginLeft:"4px" }}
              />
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                <Tooltip
                  title={<div>
                    <div>1.实物投诉：售后商品出现问题处理，需要将货物寄回</div>
                    <div>2.无实物投诉：售后商品出现问题处理，不需要将货物寄回，视客可提供顾客信息，供应商可按投诉信息核销</div>
                    <div>3.减账：直接从货款扣除相应金额</div>
                    <div>4.换货：供应商提供新的货物</div></div>
                  }>
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>售后处理方式：</span>
              <Select
                showSearch
                style={{ width: 150, marginRight: '4px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && (addData.item_info.is_supply_complaint || addData.item_info.is_supply_complaint === 0) ? addData.item_info.is_supply_complaint : undefined}
                onChange={(e) => handelChangeSource(e, 'is_supply_complaint')}
              >
                <Option key={0} name='is_supply_complaint' value={0}>实物投诉</Option>
                <Option key={1} name='is_supply_complaint' value={1}>无实物投诉</Option>

              </Select>
              <Select
                showSearch
                style={{ width: 90, marginRight: '4px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && addData.item_info.after_sale_problem ? addData.item_info.after_sale_problem : undefined}
                onChange={(e) => handelChangeSource(e, 'after_sale_problem')}
              >
                <Option key={0} name='after_sale_problem' value={'减账'}>减账</Option>
                <Option key={1} name='after_sale_problem' value={'换货'}>换货</Option>

              </Select>
            </section>
          </div>

          <div className={styles.total_title}>
            <span className={styles.titles}>返利政策</span>
          </div>

          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>有无返利：</span>
              <Select
                showSearch
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && (addData.item_info.is_rebate || addData.item_info.is_rebate === 0) ? addData.item_info.is_rebate : undefined}
                onChange={(e) => handelChangeSource(e, 'is_rebate')}
              >
                <Option key={0} name='is_rebate' value={1}>有</Option>
                <Option key={1} name='is_rebate' value={0}>无</Option>
              </Select>
            </section>

            <section className={styles.publicsection} style={{display: addData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>返利点数：</span>
              <InputNumber
                placeholder='请输入'
                min={0}
                max={100}
                precision={2}
                addonAfter='%'
                value={get(addData,'item_info.rebate_point')?Number(get(addData,'item_info.rebate_point')):null}
                onChange={(e)=>{iptNumChange(e,'rebate_point')}}
                style={{ width: 144, marginRight: '0px',marginRight:"4px" }}
              />
            </section>

            <section className={styles.publicsection} style={{display: addData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
                <Tooltip title={<div>
                  <div>1.含税：按照含税价格计算返点</div>
                  <div>2.不含税：按照不含税价格计算返点</div>
                </div>}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>返利基数：</span>

              <Select
                showSearch
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && addData.item_info.rebate_base ? addData.item_info.rebate_base : undefined}
                onChange={(e) => handelChangeSource(e, 'rebate_base')}
              >
                <Option key={0} name='rebate_base' value='no_tax'>不含税</Option>
                <Option key={1} name='rebate_base' value='tax'>含税</Option>
              </Select>
            </section>

            <section className={styles.publicsection} style={{display: addData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
                返利生成时间点：</span>

              <Select
                showSearch
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && addData.item_info.rebate_note ? addData.item_info.rebate_note : undefined}
                onChange={(e) => handelChangeSource(e, 'rebate_note')}
              >
                <Option key={0} name='rebate_note' value='return_money'>回款</Option>
                <Option key={1} name='rebate_note' value='stock'>进货</Option>
              </Select>
            </section>

            <section className={styles.publicsection} style={{display: addData.item_info.is_rebate === 1 ? 'inline-block' : 'none'}}>
              <span className={styles.publlictitle}><span className={styles.required}>*</span>
                <Tooltip title={<div>
                  <div>1.减账：最近一期到期应付款中扣减</div>
                  <div>2.货返：用商品结算</div>
                  <div>3.现金打款：现金电汇</div>
                </div>}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>兑现方式：</span>

              <Select
                showSearch
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                allowClear
                value={addData && addData.item_info.rebate_type ? addData.item_info.rebate_type : undefined}
                onChange={(e) => handelChangeSource(e, 'rebate_type')}
              >
                <Option key={0} name='rebate_type' value='reduce'>减账</Option>
                <Option key={1} name='rebate_type' value='goods'>货返</Option>
                <Option key={2} name='rebate_type' value='cash'>现金打款</Option>
              </Select>
            </section>
          </div>

          <div
            style={{
              width: '100%',
              marginBottom: '24px',
              marginTop: '56px',
              textAlign: 'center'
            }}
          >
            <Button
              type=""
              loading = {btnsLoading.preservationLoading}
              style={{ margin: '0px 8px' }}
              onClick={handlePreservation}
              shape="round"
            >
            保存
            </Button>
            <Button
              type=""

              style={{ margin: '0px 8px' }}
              onClick={handleBack}
              shape="round"
            >
          上一步
            </Button>
            <Button
              type="primary"
              loading = {btnsLoading.okLoading}
              style={{ margin: '0px 8px' }}
              onClick={handleOk}
              shape="round"
            >
          提交
            </Button>
          </div>
        </div>
      </div>
    </Spin>
  )
}
export default CooperationInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/cooperation-information.js